<template>
  <div class='lvxin'>

    <img class="title" src="@/assets/family/lvxin/title.jpg" alt="">
    <div class="container">
      <img class="image" src="@/assets/family/lvxin/0.png" alt="">
    </div>


  </div>
</template>

<script>
export default {
  name: 'lvxin',
  components: {
  },
  data() {
    return {
    }
  },
  computed: { },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang='less' scoped>
.lvxin {
  max-width: 1920px;
  margin: 0 auto;
  .title{
    vertical-align: top;
    width: 100%;
    max-width: 1920px;
  }
  .container {
		max-width: 1920px;
		margin: 0 auto;
		padding: 60px 220px;
		.image {
			width: 100%;
			vertical-align: top;
			display: block;
		}
	}
}
</style>
